import { Component } from '@angular/core';
import { LandingPageService } from '../landing-page/landing-page.service';
import { Router } from '@angular/router';
import { SharingDataService } from 'src/sharing-data.service';
import { maleProducts } from './maleProductsModel'; 
@Component({
  selector: 'app-men-oversized-primted',
  templateUrl: './men-oversized-primted.component.html',
  styleUrls: ['./men-oversized-primted.component.css']
})
export class MenOversizedPrimtedComponent {

   ngAfterViewInit() {
    // This executes right after the HTML hits the screen
    setTimeout(() => {
      // Fake a window resize event to force the browser to snap the header and banner together
      window.dispatchEvent(new Event('resize'));
    }, 50); // A 50ms delay is invisible to the user but enough for the browser
  }
  ngOnInit(): void {
    // Your initialization logic here
    console.log('Component initialized!');
    this.viewAllFourProducts();
     this.viewAllMaleProducts();
    this. viewProductComponent=false;
    this.Cart=0;
  }
  Cart=0;
  products:any;
  maleProducts:any;
  viewProductComponent=false;
malePrinted: any[] = [];
    maleProductsJson: maleProducts={
      productId : 0,
   productDescription: '',
    productPrize: '',
    inStock: '',
    productName:'',
    category :'',
    productImage : ''
    };
  constructor(private landingPageService : LandingPageService,private router: Router,private sharingData: SharingDataService){}
  tshirts = [
    { src: '../../assets/img/tshirt1.jpg', name: 'Black T Rs699' , label: 'Add to Cart'},
    { src: '../../assets/img/tshirt1.jpg', name: 'Red T Rs699' , label: 'Add to Cart' },
    { src: '../../assets/img/tshirt1.jpg', name: 'White T Rs699' , label: 'Add to Cart' },
    { src: '../../assets/img/tshirt1.jpg', name: 'Blue T Rs699' , label: 'Add to Cart' }
   
  ];

  addToCart(tshirt:any){
    this.Cart=this.Cart+1;
    console.log("Cart=",this.Cart);
    console.log("tshirt=",tshirt.name);
   }

   viewAllFourProducts(){
    this.landingPageService.ViewAllProductsFunctions().subscribe({
      next:(response) => {
        console.log('All products are', response);
        this.products=response;
        console.log('All products are', this.products);
      },
      error: (err) => {
        console.error('Error:', err);
      }
    });
  }
  
  viewProduct(product:Object) {
    console.log(" menOversizedPlain button clicked");
    this.viewProductComponent = true;
    this.router.navigate(['/viewProducts']);
    this.sharingData.updateValue(product);
    console.log('clicked view product: ',product);
  }
  
  viewAllMaleProducts(){
  //     const targetImages=[
  //   '../../assets/img/IMG_pista_eye_man_5.jpg',
  //   '../../assets/img/IMG_man_beige_body_4.jpg',
  //   '../../assets/img/IMG_man_black_redmoon_2.jpg',
  //   '../../assets/img/IMG_man_black_redmoon_1.jpg'
  // ]
  this.sharingData.GetAllMaleProducts().subscribe({
    next:(response) => {
     
      this.maleProducts=response;
        console.log('all producrs',response)
           this.malePrinted = [];
      for(let i=0;i<this.maleProducts.length;i++){
     
       if ((this.maleProducts[i].category) == 'Printed'){
        console.log('Category is Printed');
          this.malePrinted.push(this.maleProducts[i]);
        }
      }
      console.log('All male printed are', this.malePrinted);
    },
    error: (err) => {
      console.error('Error:', err);
    }
  });
}
}


